import type { ReactElement } from "react";
import React from "react";

type IconNode = ReadonlyArray<
  [string, Record<string, string | number>]
>;

export interface LucideIconProps {
  icon: IconNode;
  size?: number | string;
  strokeWidth?: number | string;
  className?: string;
}

export const LucideIcon = ({
  icon,
  size = 18,
  strokeWidth = 2,
  className,
}: LucideIconProps): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {icon.map(([tag, attrs], index) =>
        React.createElement(tag, { ...attrs, key: index }),
      )}
    </svg>
  );
};

